import React from 'react';
import CookiesToggle from './CookiesToggle';
import T from '../components/T';

const SettingsPanel = ({ onBack, marketing, analytic, onChangeSelection, expandedState, setExpanded, setCookieContent }) => {
  const updateComponent = (update) => {
    const result = { marketing, analytic, ...update };
    onChangeSelection(result);
  };

  const updateExpanded = (member, value) => {
    const update = {
      essential: false,
      analytic: false,
      marketing: false
    };
    update[member] = value;
    setExpanded(update);
  };

  return (
    <div className="consent-panel">
      <CookiesToggle
        value
        onValueChanged={() => {}}
        id="id_essential"
        labelId="cookieConsent.settings.cookieTypeEssential"
        expanded={expandedState.essential}
        setExpanded={(expanded) => { updateExpanded('essential', expanded); }}
        disabled
      >
        <p>
          <T msg="cookieConsent.settings.essential" />
        </p>
      </CookiesToggle>
      <CookiesToggle
        value={analytic}
        onValueChanged={(newValue) => {
          updateComponent({ analytic: newValue });
        }}
        id="id_analytic"
        labelId="cookieConsent.settings.cookieTypeAnalytic"
        expanded={expandedState.analytic}
        setExpanded={(expanded) => { updateExpanded('analytic', expanded); }}
      >
        <p>
          <T msg="cookieConsent.settings.analytic" />
        </p>
      </CookiesToggle>
      <CookiesToggle
        value={marketing}
        onValueChanged={(newValue) => {
          updateComponent({ marketing: newValue });
        }}
        id="id_marketing"
        labelId="cookieConsent.settings.cookieTypeMarketing"
        expanded={expandedState.marketing}
        setExpanded={(expanded) => { updateExpanded('marketing', expanded); }}
      >
        <p>
          <T msg="cookieConsent.settings.marketing" />
        </p>
      </CookiesToggle>
      <div className="button-bar">
        <button
          type="button"
          className="c-button c-button--secondary"
          onClick={() => {
            let cookieContent = 'E';
            if (marketing) {
              cookieContent += 'M';
            }
            if (analytic) {
              cookieContent += 'A';
            }
            setCookieContent(cookieContent);
          }}
        >
          <T msg="cookieConsent.settings.buttonSave" />
        </button>
        <button
          type="button"
          className="c-button c-button--secondary"
          onClick={onBack}>
            <T msg="cookieConsent.settings.buttonBack" />
        </button>
      </div>
    </div>
  );
};

export default SettingsPanel;



// WEBPACK FOOTER //
// ./app/Assets/js/features/cookieConsent/SettingsPanel.js